import { ImporterEvent } from './importer-event';
import { ImporterEventType } from './importer-event-type';

export class EnableImportButtonEvent implements ImporterEvent {
  type = ImporterEventType.EnableImportButton;

  constructor(public enable: boolean) {}
}
